import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TSyaryoBetuUnkoSyusiListReq,
  TSyaryoBetuUnkoSyusiListRes,
} from "./TSyaryoBetuUnkoSyusi"

/**
 * 車輌経費に対するAPIリクエスト用サービス
 *
 * @export
 * @class SyaryoBetuUnkoSyusiService
 * @extends {ConnectApi}
 */
export default class SyaryoBetuUnkoSyusiService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TSyaryoBetuUnkoSyusiListReq} params
   * @memberof SyaryoBetuUnkoSyusiService
   */
  getList = async (params: TSyaryoBetuUnkoSyusiListReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TSyaryoBetuUnkoSyusiListRes[]>> =
        await this.getInner(
          `/budget/syaryobetuunkosyusi/syaryobetuunkosyusi/list`,
          params
        )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
